import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    background: theme.colors.Background3,
    borderRadius: theme.radius.small,
    padding: theme.spacing.space12,
    alignItems: "center",
    height: 54,
  },
  content: {
    display: "flex",
    gap: 8,
  },
  contentText: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    justifyContent: "center",
  },
  image: {
    borderRadius: theme.radius.small,
    width: 48,
    height: 48,
    "&.service": {
      borderRadius: "50%",
    },
  },
  battleImage: {
    display: "flex",
    width: 42,
    height: 55,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },
  reward: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space4,
  },
}));
